import {R1C1Location} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/R1C1';
import {ISheetLocation, SheetLocationKey, SheetType} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import {serializable} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

const CurrentCellLocation = new R1C1Location(
    0,
    false,
    0,
    false
);

export class SheetLocationImpl implements ISheetLocation
{
    @serializable public readonly sheetId:SheetId;
    @serializable public readonly columnIndex:number;
    @serializable public readonly rowIndex:number;

    constructor(sheetId:SheetId,
                columnIndex:number,
                rowIndex:number)
    {
        this.sheetId = sheetId;
        this.columnIndex = columnIndex;
        this.rowIndex = rowIndex;
    }

    public getType():SheetType
    {
        return SheetType.SheetLocation;
    }

    public toString():string
    {
        return `${CurrentCellLocation.toA1String(this.columnIndex, this.rowIndex)}`;
    }

    public toA1Location():string
    {
        return this._getNthColumnName(this.columnIndex + 1) + (this.rowIndex + 1);
    }

    public asKey():SheetLocationKey
    {
        return `${this.sheetId}_${this.columnIndex}_${this.rowIndex}`;
    }

    public isEquals(other:ISheetLocation)
    {
        return !!other
            && this.sheetId === other.sheetId
            && this.columnIndex === other.columnIndex
            && this.rowIndex === other.rowIndex;
    }

    private _getNthColumnName(n):string
    {
        let name = '';
        while( n > 0 )
        {
            n--;
            name = String.fromCharCode(('A'.charCodeAt(0) + n % 26)) + name;
            n /= 26;
        }
        return name;
    }

    public static isSheetLocation(object:any)
    {
        return object && typeof object.getType === 'function' && object.getType() === SheetType.SheetLocation;
    }
}
